import { queryOptions } from '@tanstack/react-query'
import { fetchBoard, fetchProjects, fetchTaskByKey } from './project'

/**
 * The screens' queries, defined once.
 *
 * They are shared because the warm start below fetches them before the router
 * has decided anything, and a prefetch under a key the component does not ask
 * for is a request that costs a round trip and answers nothing. One
 * definition, so the two cannot drift.
 */
/**
 * A project's board, with its finished work on it.
 *
 * Completed tasks are always included. They used to be behind a toggle, which
 * meant the Done column was usually empty and finishing something looked like
 * losing it - and the board had two cache keys, so flipping the toggle threw
 * away everything the other one had. Work leaves the board by being archived
 * now, which is a decision somebody makes rather than a switch on a screen.
 */
export const boardQuery = (projectId: string) =>
  queryOptions({
    queryKey: ['board', projectId] as const,
    queryFn: ({ signal }) => fetchBoard(projectId, true, signal),
  })

export const projectsQuery = (includeArchived = false) =>
  queryOptions({
    queryKey: ['projects', includeArchived] as const,
    queryFn: ({ signal }) => fetchProjects(includeArchived, signal),
  })

export const taskByKeyQuery = (key: string) =>
  queryOptions({
    queryKey: ['task-by-key', key.toUpperCase()] as const,
    queryFn: ({ signal }) => fetchTaskByKey(key, signal),
    // A mistyped key is an answer, not a blip worth retrying.
    retry: false,
  })
